import { wrapSvg } from '../../util/SvgImage';

export const IconGPMobile = wrapSvg(
  <svg width="43" height="40" viewBox="0 0 43 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.8021 37.4424C31.9042 37.4424 40.0935 29.253 40.0935 19.151C40.0935 9.04894 31.9042 0.859619 21.8021 0.859619C11.7001 0.859619 3.51074 9.04894 3.51074 19.151C3.51074 29.253 11.7001 37.4424 21.8021 37.4424Z"
      fill="#03676E"
    />
    <g filter="url(#filter0_d_1501_61535)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.4035 10.2339H18.8642C17.9072 10.2339 17.1313 11.0097 17.1313 11.9668V14.7855C17.1313 15.7426 17.9072 16.5184 18.8642 16.5184H24.4035C25.3605 16.5184 26.1363 15.7426 26.1363 14.7855V11.9668C26.1363 11.0097 25.3605 10.2339 24.4035 10.2339ZM18.5945 12.3134C18.5945 11.9944 18.8531 11.7357 19.1721 11.7357H23.9151C24.2341 11.7357 24.4927 11.9944 24.4927 12.3134V14.439C24.4927 14.758 24.2341 15.0166 23.9151 15.0166H19.1721C18.8531 15.0166 18.5945 14.758 18.5945 14.439V12.3134Z"
        fill="white"
      />
      <path
        d="M13.5713 13.9309H29.6959C31.2112 13.9309 32.4396 15.1593 32.4396 16.6746V25.9743C32.4396 27.4896 31.2112 28.718 29.6959 28.718H13.5713C12.056 28.718 10.8276 27.4896 10.8276 25.9743V16.6746C10.8276 15.1593 12.056 13.9309 13.5713 13.9309Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7606 17.9973C20.508 17.9973 20.3033 18.202 20.3033 18.4546V19.9595H18.8484C18.5958 19.9595 18.3911 20.1642 18.3911 20.4167V22.2321C18.3911 22.4847 18.5958 22.6894 18.8484 22.6894H20.3033V24.1942C20.3033 24.4468 20.508 24.6515 20.7606 24.6515H22.506C22.7585 24.6515 22.9632 24.4468 22.9632 24.1942V22.6894H24.4174C24.67 22.6894 24.8747 22.4847 24.8747 22.2321V20.4167C24.8747 20.1642 24.67 19.9595 24.4174 19.9595H22.9632V18.4546C22.9632 18.202 22.7585 17.9973 22.506 17.9973H20.7606Z"
        fill="#D73D00"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1501_61535"
        x="0.827637"
        y="1.23389"
        width="41.6121"
        height="38.4841"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.027451 0 0 0 0 0.137255 0 0 0 0 0.14902 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1501_61535" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1501_61535"
          result="shape"
        />
      </filter>
    </defs>
  </svg>,
);
